import * as React from 'react'
import {observer} from 'mobx-react'
import {useStores} from '../../../../lib/MobXProvider'
import {WidgetApi} from '../../../../lib/WidgetApi'
import {ErrorMessage} from '../../../ui/ErrorMessage'
import {InputCheckboxWrapper} from '../../../wrappers/InputCheckableWrapper'
import {RippleWrapper} from '../../../wrappers/RippleWrapper'
import {DirtyWrapper} from '../../../wrappers/DirtyWrapper'
import {FormPart} from '../../../wrappers/FormPart'
import {DynamicSlotName} from '../../../../lib/DynamicSlotName'
import {DynamicSlot} from '../../../dynamic/DynamicSlot'

///////////////////////////////////////////////////////////////////////////////

export const PaymentCoverFee = observer(() => {
  const {api} = useStores<{api: WidgetApi}>()
  const form = api.paymentForm
  const formData = form.data
  const errors = form.validationErrors
  const submit = () => form.validateAndSend()

  const errorId = api.ui.generateUniqueElementId(
    'stored_cover_transaction_fee-error',
  )
  const coverFee = !!formData.stored_cover_transaction_fee
  const setCoverFee = (value: boolean) =>
    (formData.stored_cover_transaction_fee = value)

  return (
    <fieldset>
      <legend>{api.trans('blocks.payment_cover_fee.legend')}</legend>

      <FormPart className="payment-cover-fee" onSubmit={submit}>
        <DynamicSlot name={DynamicSlotName.COVER_FEE_START} form={form} />

        <div className="form-block stored_cover_transaction_fee">
          <div className="field-block">
            <RippleWrapper>
              <label className="label-checkbox-block">
                <InputCheckboxWrapper
                  form={form}
                  fields="stored_cover_transaction_fee"
                >
                  <DirtyWrapper
                    form={form}
                    fields="stored_cover_transaction_fee"
                  >
                    <input
                      type="checkbox"
                      aria-describedby={errorId}
                      className="input-checkbox"
                      name="stored_cover_transaction_fee"
                      checked={coverFee}
                      onChange={(e) => setCoverFee(e.target.checked)}
                    />
                  </DirtyWrapper>
                </InputCheckboxWrapper>
                <span>
                  {api.trans('payment_form.stored_cover_transaction_fee')}
                </span>
              </label>
            </RippleWrapper>
          </div>
          <ErrorMessage
            errors={errors}
            errorKey="stored_cover_transaction_fee"
            id={errorId}
          />
        </div>

        <DynamicSlot name={DynamicSlotName.COVER_FEE_END} form={form} />
      </FormPart>
    </fieldset>
  )
})
